import { css } from 'styled-components';

export const sliderStyles = css`
  cursor: pointer;

  &:active {
    background-color: ${({ theme }) => theme.color.primary[700].value};
  }

  &:hover {
    background-color: ${({ theme }) => theme.color.primary[600].value};
  }

  &:focus {
    background-color: ${({ theme }) => theme.color.primary[700].value};
  }

  &:disabled {
    background-color: ${({ theme }) => theme.color.gray[600].value};
  }
`;
